import script from "./classInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./classInfo.vue?vue&type=script&setup=true&lang=js"

import "./classInfo.vue?vue&type=style&index=0&id=e7aae8ca&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e7aae8ca"]])

export default __exports__